import script from "./SignUpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__